import * as Yup from 'yup';
import { ObjectSchema } from 'yup';
import { BedType, RoomType } from 'models/PropertyRooms';

const bedTypeDescriptor = () =>
  Yup.object({
    bedType: Yup.mixed<BedType>().oneOf(Object.values(BedType)).required(),
    count: Yup.number().integer().positive().required(),
  });

export const roomsAndBedTypesFormSchema = () => ({
  rooms: Yup.array()
    .of(
      Yup.object({
        beds: Yup.array().of(bedTypeDescriptor()).required(),
        bedTypes: Yup.string().when(['beds', 'roomType'], {
          is: (beds: BedTypeDescriptor[], roomType: RoomType) =>
            roomType === RoomType.BEDROOM && !beds?.length,
          then: (schema) =>
            schema.required({
              key: 'pageProperty.mainSettings.capacityDetails.setRoomsAndBedTypesModal.validation.beds',
            }),
          otherwise: (schema) => schema,
        }),
        hasPrivateBathroom: Yup.boolean().when('roomType', {
          is: (roomType: RoomType) => roomType === RoomType.BEDROOM,
          then: (schema) => schema.required(),
          otherwise: (schema) => schema.notRequired(),
        }),
        roomType: Yup.mixed<RoomType>()
          .oneOf(Object.values(RoomType))
          .required(),
        sharedRoom: Yup.boolean().when('roomType', {
          is: (roomType: RoomType) => roomType === RoomType.LIVING_ROOM,
          then: (schema) => schema.required(),
          otherwise: (schema) => schema.notRequired(),
        }),
        uid: Yup.string().nullable().optional(),
      }),
    )
    .required(),
});

export type BedTypeDescriptor = Yup.InferType<
  ReturnType<typeof bedTypeDescriptor>
>;

export type RoomsAndBedTypesFormValues = Yup.InferType<
  ObjectSchema<ReturnType<typeof roomsAndBedTypesFormSchema>>
>;
